<template>

  <div class="forum-container">
    <div class="forum-left-box">
      <forum-nav
              @select="handleMenuSelect"
              :menuList="menuList">
      </forum-nav>
    </div>

    <div class="forum-right-box">
      <div class="forum-data-container">

        <div class="ks-board-box" v-if="menuIndex !== 0" ref="ksBoardBox">
          <div class="ks-board-header">
            <div class="ks-header-first-line">
              <span class="header-ks-title">{{ departmentName }}</span>
              <el-button
                      :class="['ks-focus-btn', focused ? 'has-focus' : 'non-focus']"
                      :icon="focused ? '' : 'el-icon-plus'"
                      @click="handleFocusClick"
              >{{ focused ? '已关注' : '关注' }}</el-button>
            </div>
            <div class="ks-header-second-line">
              <p>
                <span>内容</span>
                <span>{{ totalRowCount }}</span>
              </p>
              <p>
                <span>关注</span>
                <span>{{ focusCount }}</span>
              </p>
              <p>
                <span>今日更新</span>
                <span>{{ todayNewCount }}</span>
              </p>
            </div>
          </div>
          <div class="ks-board-content-box">
            <forum-content
                    :menu-index="menuIndex"
                    :discuss-data="discussData">
            </forum-content>
          </div>
      </div>
<!--        <el-scrollbar style="height:calc(100% - 38px);" v-if="menuIndex === 0">-->
        <el-tabs v-model="activeTab"
                 v-if="menuIndex === 0"
                 @tab-click="handleTabClick">

          <el-tab-pane label="关注" name="focus">

            <forum-content
                    :menu-index="menuIndex"
                    :discussData="discussFocusData"
                    v-if="activeTab==='focus'"></forum-content>

          </el-tab-pane>

          <el-tab-pane label="热门" name="hot">
            <forum-content
                    :menu-index="menuIndex"
                    :discussData="discussHotData"
                    v-if="activeTab==='hot'"></forum-content>
          </el-tab-pane>
        </el-tabs>
<!--        </el-scrollbar>-->
        <div class="content-pager-box">
          <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page.sync="pageIndex"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size.sync="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalRowCount" style="text-align: right; margin-top: 5px;">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import api from '@/api/forumData';
  import UI from '@/mixins/ui';
  import ForumNav from "@/pages/forum/components/ForumNav";
  import ForumContent from "@/pages/forum/components/ForumContent";
  import forumApi from '@/api/forumData';
  export default {
    name: 'Forum',
    mixins: [UI],
    components: {
      ForumNav,
      ForumContent,
    },
    data() {

      return {
        activeTab: 'focus',
        pageIndex: 1,
        pageSize: 10,
        totalRowCount: 0,
        menuList: [],
        discussFocusData:[],
        discussHotData:[],

        departmentId: '',
        departmentName: '',
        focused: false,
        focusCount: 0,
        todayNewCount: 0,
        discussData: [],

        menuIndex: 0,
      }
    },

    methods: {

      handleTabClick (tab, event) {
        this.pageIndex = 1;
        this.getDiscussData();
      },

      handleSizeChange (newSize) {
        this.pageIndex = 1;
        this.pageSize = newSize;
        if (this.menuIndex === 0) {
          this.getDiscussData();
        } else {
          this.loadKsDiscussList(this.departmentId);
        }
      },

      handleCurrentChange (curNo) {
        this.pageIndex = curNo;
        if (this.menuIndex === 0) {
          this.getDiscussData();
        } else {
          this.loadKsDiscussList(this.departmentId);
        }
      },
      async getDiscussData(){
        let scrollDiv = document.getElementsByClassName('el-tabs el-tabs--top')[0];
        if(this.activeTab==='focus'){
          this.loadingData('.forum-right-box', async () => {
            let resF = await forumApi.getFocusList(this.pageIndex,this.pageSize);
            console.log('focus %o', resF);
            if (resF && resF.data) {
              this.discussFocusData = resF.data;
              this.pageIndex = resF.pageIndex;
              this.pageSize = resF.pageSize;
              this.totalRowCount = resF.totalRowCount;
            }
          });
        }

        if(this.activeTab==='hot') {
          this.loadingData('.forum-right-box', async () => {
            let resH = await forumApi.getHotList(this.pageIndex,this.pageSize);
            console.log('hot %o', resH);
            if (resH && resH.data) {
              this.discussHotData = resH.data;
              this.pageIndex = resH.pageIndex;
              this.pageSize = resH.pageSize;
              this.totalRowCount = resH.totalRowCount;
            }
          });
        }
        this.scrollToTop(scrollDiv, 0.05);
      },

      async loadForumMenuList () {
        let res = await api.getKsList();
        if (res) {
          let menuList = [];
          let arrItem = {
            category: '我关注的',
            departments: res.focus,
          };
          menuList.push(arrItem);
          if (res.all && res.all.length != 0) {
            menuList.push.apply(menuList, res.all);
          }
          this.menuList = menuList;
        }

      },

      handleMenuSelect (deptId, index, callback) {
          this.menuIndex = 1;
          this.pageIndex = 1;
          this.loadKsDiscussList(deptId);
          callback && callback();
      },

      async loadKsDiscussList (deptId) {
        this.loadingData('.forum-right-box', async () => {
          let res = await api.getKsDiscussList(this.pageIndex, this.pageSize, deptId);
          if (res && res.data) {
            this.departmentId = res.departmentId;
            this.departmentName = res.departmentName;
            this.totalRowCount = res.totalRowCount;
            this.focused = res.focused;
            this.focusCount = res.focusCount;
            this.todayNewCount = res.todayNewCount;
            this.pageIndex = res.pageIndex;
            this.pageSize = res.pageSize;
            this.discussData = res.data;
          }
          this.scrollToTop(this.$refs['ksBoardBox'], 0.05);
        });
      },

      async handleFocusClick () {
        if (!this.departmentId || this.departmentId === '') {
          return;
        }
        if (this.focused) {
          let res = await api.deleteFocusKs(this.departmentId);
          if (res) {
            this.focused = false;
          }
        } else {
          let res = await api.addFocusKs(this.departmentId);
          if (res) {
            this.focused = true;
          }
        }
        this.loadForumMenuList();
      },

    },

    created() {
      this.loadForumMenuList();
      this.getDiscussData();
    },

    mounted() {

    }
  }
</script>

<style lang="less" scoped>

  .forum-container {
    display: flex;
    width: calc(100% - 200px);
    height: 100%;
    margin: 0 100px;

    .forum-left-box {
      background-color: #FFF;
      width: 200px;
    }

    .forum-right-box {
      width: 100%;
      height: 100%;
      margin-left: 18px;
      background-color: #FFF;

      .forum-data-container {
        width: calc(100% - 40px);
        height: calc(100% - 32px);
        margin: 12px 20px 20px;
        font-size: 14px;
        color: #333;

        .ks-board-box {
          height: calc(100% - 30px);

          .ks-board-header {
            height: 70px;
            border-bottom: 1px solid #DCDFE6;

            .ks-header-first-line {

              .header-ks-title {
                font-size: 20px;
                color: #373434;
                display: inline-block;
                vertical-align: -4px;
              }

              .ks-focus-btn {
                width: 80px;
                height: 30px;
                padding: 0;
                font-size: 12px;
                margin-left: 24px;
                border-radius: 4px;
              }

              .has-focus {
                background-color: #FFF;
                color: #AAA;
              }

              .non-focus {
                background-color: #1DAABA;
                color: #FFF;
              }
            }

            .ks-header-second-line {
              margin-top: 15px;

              span {
                font-size: 12px;
                color: #AFAFAF;
                padding: 4px;
              }

              p {
                margin: 0;
                padding: 0;
                display: inline-block;
              }

              p:not(:first-child) {
                padding-left: 10px;
              }
            }
          }

          .ks-board-content-box {
            height: calc(100% - 115px);
            margin-top: 30px;
          }
        }

      }
    }
  }

</style>

<style lang="less">

  .forum-container {

    .forum-left-box {

    }
    .el-scrollbar__wrap{
      overflow-y: scroll;
      overflow-x: hidden;
    }
    .forum-right-box {


      .forum-data-container {

        .el-tabs {
          height: calc(100% - 32px);
          overflow: auto;

          .el-tabs__content {
            height: calc(100% - 54px);
            overflow: auto;
          }

          .el-tab-pane {
            height: 100%;
            overflow: auto;
          }
        }

        .ks-board-box {
          height: calc(100% - 70px);
          overflow: auto;
        }

        .el-tabs__item.is-active,
        .el-tabs__item:hover {
          color: #1DAABA;
        }

        .el-tabs__active-bar {
          background-color: #1DAABA;
        }

        .content-pager-box {

          .el-pagination {
            font-size: 12px;
          }

          .el-pagination.is-background .el-pager li:not(.disabled).active {
            background-color: #1DAABA;
          }
        }

      }
    }
  }

</style>
